// Custom limited-order frontend behavior.
// Caps quantities and lets Shopify Functions surface limited-order errors in product forms.
(function () {
  const limitedQuantitySelector = '[data-custom-limited-quantity="true"]';
  const limitedProductSelector = '[data-custom-limited-product="true"]';

  function capLimitedQuantities(root = document) {
    root.querySelectorAll(limitedQuantitySelector).forEach((input) => {
      const max = Number(input.getAttribute('data-custom-limited-max') || input.getAttribute('max') || 1);

      if (!Number.isFinite(max)) {
        return;
      }

      input.setAttribute('max', String(max));

      if (Number(input.value) > max) {
        input.value = String(max);
        input.dispatchEvent(new Event('change', {bubbles: true}));
      }

      const quantityWrapper = input.closest('quantity-input');
      const plusButton = quantityWrapper?.querySelector('[name="plus"], [name="increase"]');

      if (plusButton && Number(input.value) >= max) {
        plusButton.setAttribute('disabled', 'disabled');
        plusButton.classList.add('disabled');
      }
    });
  }

  // The theme's inventory guard otherwise suppresses a Function error and runs its success animation.
  function prepareLimitedProductSubmission(event) {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    const submitButton = event.submitter || form.querySelector(`[data-add-to-cart]${limitedProductSelector}`);

    if (!submitButton?.matches(limitedProductSelector)) {
      return;
    }

    form.setAttribute('data-max-inventory-reached', 'false');
    form.setAttribute('data-error-message-position', 'form');
  }

  // Prevent Countdown buttons flashing the theme's default text while variant data loads.
  function preserveLaunchStateDuringVariantLoad(event) {
    const optionTarget = event?.data?.event?.target;
    const productInfo = optionTarget?.closest?.('product-info');
    const launchButton = productInfo?.querySelector('[data-add-to-cart][data-custom-launch-disabled="true"]');

    if (!launchButton) {
      return;
    }

    const buttonText = launchButton.querySelector('[data-add-to-cart-text]');
    launchButton.disabled = true;
    launchButton.classList.add('btn--custom-launch-disabled');

    if (buttonText) {
      buttonText.textContent = launchButton.dataset.customLaunchText || 'Coming Soon';
    }

    productInfo.querySelector('[data-form-wrapper]')?.classList.remove('variant--soldout');
  }

  // Preserve the launch state after the theme refreshes variant availability.
  function enforceCustomProductState(event) {
    const sectionId = event?.data?.sectionId;
    const responseHtml = event?.data?.html;

    if (!sectionId || !responseHtml) {
      return;
    }

    const responseButton = responseHtml.getElementById(`ProductSubmitButton-${sectionId}`);
    const currentButton = document.getElementById(`ProductSubmitButton-${sectionId}`);

    if (!responseButton || !currentButton) {
      return;
    }

    const isLaunch = responseButton.dataset.customLaunchDisabled === 'true';
    if (!isLaunch) {
      return;
    }

    const buttonText = currentButton.querySelector('[data-add-to-cart-text]');
    const productInfo = currentButton.closest('product-info');
    const quantityForm = productInfo?.querySelector('.product-form__quantity');

    currentButton.disabled = true;
    currentButton.classList.add('btn--custom-launch-disabled');
    currentButton.dataset.customLaunchDisabled = 'true';

    if (buttonText) {
      buttonText.textContent = responseButton.dataset.customLaunchText || 'Coming Soon';
    }

    quantityForm?.classList.add('product-form__quantity--custom-launch-disabled');
    quantityForm?.querySelectorAll('button, input, [data-popout-toggle]').forEach((control) => {
      if ('disabled' in control) {
        control.disabled = true;
      }
      control.setAttribute('aria-disabled', 'true');
    });

    productInfo?.querySelector('[data-form-wrapper]')?.classList.remove('variant--soldout');
  }

  document.addEventListener('shopify:section:load', (event) => {
    capLimitedQuantities(event.target);
  });

  document.addEventListener('submit', prepareLimitedProductSubmission, true);

  if (window.theme?.PUB_SUB_EVENTS?.variantChange && typeof window.subscribe === 'function') {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, enforceCustomProductState);
  }

  if (window.theme?.PUB_SUB_EVENTS?.optionValueSelectionChange && typeof window.subscribe === 'function') {
    window.subscribe(window.theme.PUB_SUB_EVENTS.optionValueSelectionChange, preserveLaunchStateDuringVariantLoad);
  }

  capLimitedQuantities();
})();
